var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 56,
    viewBox: "0 0 141 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.5576 33.1276H78.2087V40.3706H71.7002V16.6839H81.9768C87.0662 16.6839 90.7853 20.1097 90.7853 25.0526C90.7853 27.94 89.3662 30.338 87.0172 31.7573L91.7151 40.3706H84.4236L80.5576 33.1276ZM78.2087 27.6464H81.1938C83.0044 27.6464 84.0811 26.5697 84.0811 25.0526C84.0811 23.5844 83.0534 22.5077 81.1938 22.5077H78.2087V27.6464Z",
    fill: "#0512C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4229 31.2196C91.4229 25.5426 95.7292 21.4807 101.651 21.4807C107.572 21.4807 111.878 25.5426 111.878 31.2196C111.878 36.8477 107.572 40.9586 101.651 40.9586C95.6803 40.9586 91.4229 36.8966 91.4229 31.2196ZM105.565 31.2196C105.565 28.8216 103.902 27.1576 101.602 27.1576C99.3016 27.1576 97.6378 28.8216 97.6378 31.2196C97.6378 33.6177 99.3016 35.2816 101.602 35.2816C103.951 35.3306 105.565 33.6666 105.565 31.2196Z",
    fill: "#0512C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.496 29.212V40.3702H125.183V30.0929C125.183 27.9885 124.4 26.9119 122.785 26.9119C120.828 26.9119 119.702 28.2822 119.702 30.6313V40.3702H113.39V22.1158H117.794L118.675 23.9755C120.045 22.4584 122.051 21.5285 124.449 21.5285C128.707 21.5774 131.496 24.5628 131.496 29.212Z",
    fill: "#0512C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.192 34.5469H140.309V40.3707H134.192V34.5469ZM134.339 15.9988H140.212V32.4914H134.339V15.9988Z",
    fill: "#0512C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3485 27.3553V23.8806C14.3485 22.9018 14.5932 21.972 14.9847 21.0911L5.19745 26.4744C5.19745 26.4744 3.58255 27.5022 2.21234 29.3129C1.82085 29.8513 1.42937 30.4385 1.13575 31.1237C0.891069 31.8088 0.695312 32.5429 0.695312 33.3259C0.695312 35.4303 1.77192 37.2901 3.33788 38.4157C3.43575 38.4646 3.48469 38.5135 3.53362 38.5625C3.58256 38.5625 3.58255 38.6114 3.63149 38.6114L5.39319 39.6392L14.3975 44.8267L14.2996 40.1775V27.3553H14.3485Z",
    fill: "#93CD87"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_309_650",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 41,
    height: 32
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9655 1.02664L3.67608 9.29742C1.37607 10.6188 0.00585938 13.0658 0.00585938 15.6596V30.3904C0.00585938 30.3414 0.0547986 30.3414 0.0547986 30.2925C0.642033 28.0902 2.11013 26.2305 4.06757 25.1538L18.1123 17.3724L20.2165 16.149L32.157 9.24847C34.457 7.92711 37.2463 7.92711 39.5463 9.24847L40.1336 9.59106C39.9868 9.49318 39.8399 9.34635 39.6442 9.24847L25.3548 0.977692C24.2293 0.341478 22.957 -0.00109863 21.6846 -0.00109863C20.3633 -0.00109863 19.091 0.341481 17.9655 1.02664Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_309_650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.13086 0.929411L38.9117 -6.75409L45.2245 29.4612L1.18191 37.1447L-5.13086 0.929411Z",
    fill: "url(#paint0_linear_309_650)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5326 28.6289V32.1036C42.5326 33.0824 42.288 34.0122 41.8965 34.8932L51.6837 29.5098C51.6837 29.5098 53.2986 28.4821 54.6688 26.6713C55.0603 26.133 55.4518 25.5457 55.7454 24.8605C55.9901 24.1754 56.1859 23.4413 56.1859 22.6583C56.1859 20.5539 55.1093 18.6942 53.5433 17.5686C53.4454 17.5196 53.3965 17.4707 53.3476 17.4217C53.2986 17.4217 53.2986 17.3728 53.2497 17.3728L51.488 16.3451L42.4837 11.1575L42.5816 15.8067V28.6289H42.5326Z",
    fill: "#74CEE2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_309_650",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 25,
    width: 41,
    height: 31
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8688 25.6929C56.2816 27.8952 54.8135 29.7549 52.856 30.8316L38.8113 38.613L36.7071 39.8365L24.7666 46.7369C22.4666 48.0583 19.6773 48.0583 17.3773 46.7369L16.79 46.3943C16.9368 46.4922 17.0837 46.6391 17.2794 46.7369L31.5688 55.0077C33.8688 56.3291 36.6581 56.3291 38.9581 55.0077L53.2475 46.7369C55.5475 45.4156 56.9177 42.9686 56.9177 40.3748V25.644C56.9177 25.644 56.8688 25.644 56.8688 25.6929Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_309_650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.1057 55.3979L17.9652 63.0814L11.6035 26.5235L55.744 18.84L62.1057 55.3979Z",
    fill: "url(#paint1_linear_309_650)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_309_650",
    x1: -4.312,
    y1: 19.443,
    x2: 36.3827,
    y2: 12.3661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1.38523e-7,
    stopColor: "#1D1753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    stopColor: "#2A338D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#5B91CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7782,
    stopColor: "#6CBE45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD008"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_309_650",
    x1: 61.2337,
    y1: 36.696,
    x2: 20.539,
    y2: 43.7729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1.38523e-7,
    stopColor: "#1D1753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    stopColor: "#2A338D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#5B91CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7782,
    stopColor: "#6CBE45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD008"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.64f003a4be4ccbc0a9933d25a5d6840b.svg";
export { ForwardRef as ReactComponent };